// extracted by mini-css-extract-plugin
export var container = "survey-item-module--container--ivPCJ";
export var date = "survey-item-module--date--L2l5S";
export var dot = "survey-item-module--dot--85xyB";
export var icon = "survey-item-module--icon--vUB7q";